import { render, staticRenderFns } from "./CreateTaxRate.vue?vue&type=template&id=070bbda6"
import script from "./CreateTaxRate.vue?vue&type=script&lang=js"
export * from "./CreateTaxRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports